export const SEARCH_FLIGHTS_TEXT = "Search Flights";
export const OUTBOUND = "Outbound";
export const RETURN = "Return";
